import React from 'react';
import '@/app/styles/loading-screen.scss';

export const LoadingScreen: React.FC = () => {
  return (
    <div className="loading-screen" data-testid="loading-screen">
      <div className="loading-content">
        <div className="loading-logo-container">
          <div className="loading-spinner" />
          <img
            src="/512x512.png"
            alt="Chill Airwaves"
            className="loading-logo"
          />
        </div>
      </div>
    </div>
  );
};